import { Plural, Trans } from '@lingui/macro'

import { HYDRACHAIN_BLOG_URL } from './chainInfo'
import { ZERO_ADDRESS } from './misc'
import { NATIVE_CHAIN_ID } from './tokens'

export const TOKEN_SAFETY_ARTICLE = HYDRACHAIN_BLOG_URL

export enum WARNING_LEVEL {
  MEDIUM,
  UNKNOWN,
  BLOCKED,
}

export function getWarningCopy(warning: Warning | null, plural = false) {
  let heading = null,
    description = null
  if (warning) {
    switch (warning.level) {
      case WARNING_LEVEL.MEDIUM:
        heading = (
          <Plural
            value={plural ? 2 : 1}
            _1="This token isn't traded on leading U.S. centralized exchanges."
            other="These tokens aren't traded on leading U.S. centralized exchanges."
          />
        )
        description = <Trans>Always conduct your own research before trading.</Trans>
        break
      case WARNING_LEVEL.UNKNOWN:
        heading = (
          <Plural
            value={plural ? 2 : 1}
            _1="This token isn't traded on leading U.S. centralized exchanges or frequently swapped on HydraDex."
            other="These tokens aren't traded on leading U.S. centralized exchanges or frequently swapped on HydraDex."
          />
        )
        description = <Trans>Always conduct your own research before trading.</Trans>
        break
      case WARNING_LEVEL.BLOCKED:
        description = (
          <Plural
            value={plural ? 2 : 1}
            _1="You can't trade this token using the HydraDex App."
            other="You can't trade these tokens using the HydraDex App."
          />
        )
        break
    }
  }
  return { heading, description }
}

export type Warning = {
  level: WARNING_LEVEL
  message: JSX.Element
  /* canProceed determines whether triangle/slash alert icon is used, and
    whether this token is supported/able to be traded */
  canProceed: boolean
}

const MediumWarning: Warning = {
  level: WARNING_LEVEL.MEDIUM,
  message: <Trans>Caution</Trans>,
  canProceed: true,
}

export function checkWarning(tokenAddress: string) {
  if (tokenAddress === NATIVE_CHAIN_ID || tokenAddress === ZERO_ADDRESS) {
    return null
  } else if (tokenAddress === '0x0') {
    // SAMVI Info: DISABLED WARNING LEVELS
    return MediumWarning
  } else {
    return null
  }
  // switch (WarningCache.checkToken(tokenAddress.toLowerCase())) {
  //   case TOKEN_LIST_TYPES.UNI_DEFAULT:
  //     return null
  //   case TOKEN_LIST_TYPES.UNI_EXTENDED:
  //     return MediumWarning
  //   case TOKEN_LIST_TYPES.UNKNOWN:
  //     return StrongWarning
  //   case TOKEN_LIST_TYPES.BLOCKED:
  //     return BlockedWarning
  //   case TOKEN_LIST_TYPES.BROKEN:
  //     return BlockedWarning
  // }
}
